import React from 'react'
import { Link } from 'gatsby'

const activStyles = {
  color: '#a0a0a0',
}
// check if link is external or internal
const isExternal = str => /^http/.test(str)
const isInternal = to => /^\/(?!\/)/.test(to)

const NavLink = ({ children, to, className }) =>
  isExternal(to) || !isInternal(to) ? (
    <a href={to}>{children}</a>
  ) : (
    <Link
      to={to}
      // activeClassName="w3-black" // activeClassName — a class name that will only be added to the Link when the current item is active
      className={className}
      activeStyle={activStyles} // activeStyle — a style object that will only be applied when the current item is active
    >
      {children}
    </Link>
  )

export default NavLink
